import { Record } from "immutable";

import { SchoolInfoI } from "@seneca/schools-service-types";

export type { SchoolInfoI as SchoolInfoType };
export type PartialSchoolInfoType = Partial<SchoolInfoI>;

const defaultSchoolInfo = {
  schoolId: undefined,
  name: undefined,
  region: undefined,
  localAuthority: undefined,
  town: undefined,
  internationalSchool: undefined,
  mat: undefined,
  privateSchool: undefined,
  urn: undefined
};

export default class SchoolInfo extends Record<PartialSchoolInfoType>(
  defaultSchoolInfo
) {}
